<template>
  <span>
    <i v-if="notEligible" class="ti-alert text-danger" :title="reason" ></i>
    <i v-if="hasStock" class="ti-truck text-success" title="Associado ao estoque." ></i>
    <i v-if="oldWinner" class="ti-medall-alt text-danger" title="Cliente já contemplado anteriormente." ></i>
    <i v-if="winner" class="ti-medall-alt text-warning" title="Ganhador" ></i>
    <i v-if="wasDocumented" class="ti-files text-primary" title="Documentado" ></i>
    <i v-if="checkIn" class="ti-check text-success" title="Presença registrada" ></i>
  </span>
</template>
<script>
export default {
  name: 'icons-ticket-list',

  props: {
    ticket: {
      required: true
    },

    notEligible: {
      default: false
    },

    reason: {
      default: 'Não é elegível'
    }
  },

  computed: {
    hasStock () {
      return this.ticket && this.ticket.stockId
    },

    oldWinner () {
      return this.ticket && this.ticket.customer && this.ticket.customer.contemplated
    },

    winner () {
      return this.ticket && this.ticket.winner
    },

    wasDocumented () {
      return this.ticket && this.ticket.documentedAt && this.ticket.documentedAt !== null
    },

    checkIn () {
      return this.ticket && this.ticket.checkIn
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/pages/Tickets/IconsTicketList.vue